import { } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { TabularCopySource } from 'app/model/pipeline/copysource/tabular-type.copysource';
import { DynamicsEntityDataset } from 'app/model/dataset/dynamics-entity.dataset';

@Metamodel.model({
    name: 'DynamicsSource',
    display: [],
    tags: { datasetModel: Metamodel.modelFor(DynamicsEntityDataset) }
})
export class DynamicsCopySource extends TabularCopySource {
}
